/** Ab dieser Länge bleibt die Bestätigung bei den ersten Nummern und zählt den Rest. */
const RECEIPT_NUMBER_LIMIT = 8;

/** Kompakte Bestätigung der Sammelaufnahme: Anzahl und, wenn vorhanden, die Fallnummern. */
export function batchIntakeReceiptText(input: {
  count: number;
  caseNumbers: readonly (string | null | undefined)[];
  queued: boolean;
}): string {
  const countLabel = input.count === 1 ? "1 Tier" : `${input.count} Tiere`;
  if (input.queued) {
    return `${countLabel} lokal gespeichert. Die Nummern folgen nach der Synchronisation.`;
  }
  const numbers = input.caseNumbers
    .map((value) => (typeof value === "string" ? value.trim() : ""))
    .filter((value) => value.length > 0);
  if (numbers.length === 0) return `${countLabel} aufgenommen.`;
  if (numbers.length > RECEIPT_NUMBER_LIMIT) {
    const shown = numbers.slice(0, RECEIPT_NUMBER_LIMIT);
    const rest = numbers.length - RECEIPT_NUMBER_LIMIT;
    return `${countLabel} aufgenommen: ${shown.join(", ")} … und ${rest} weitere`;
  }
  return `${countLabel} aufgenommen: ${numbers.join(", ")}`;
}
